'use strict';
angular.module('resourceEditImageModule', []).
controller('resourceEditImageCtrl', ["$scope", "$stateParams", "$timeout", "$modalInstance", "$filter", "uploadImg", "specialCase", "trsHttpService", "modalDialog",
    function($scope, $stateParams, $timeout, $modalInstance, $filter, uploadImg, specialCase, trsHttpService, modalDialog) {
        initStatus();
        initData();

        function initStatus() {
            $scope.status = {
                uploadImg: {
                    'src': uploadImg.PERPICURL
                },
                lockBtn: false,
                progress: ""
            };
            $scope.status.tilte = angular.isDefined($stateParams.channelid) ? "更换图片" : "图片编辑";
        }

        function initData() {
            $scope.callBack = {
                success: function(file, src, uploader) {
                    var uploadedSrc;
                    if(angular.isDefined(specialCase) && specialCase == 'historyPic') {
                        var picUrl = src.imgSrc.indexOf("ScaleWidth=600")>-1 ? src.imgSrc.replace("ScaleWidth=600&", "") : src.imgSrc;
                        var params = {
                            serviceid: "tpg",
                            modelid: "uploadByUrl",
                            typeid: "zyzx",
                            url: picUrl,
                            type: file.ext
                        };
                        trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                            if (data === "") {
                                modalDialog.alertType("图片上传失败", "请稍后再试", "error", false, function() {
                                    $modalInstance.dismiss();
                                });
                            } else {
                                data.HEIGHT = data.HEIGHT.toString();
                                data.WIDTH = data.WIDTH.toString();
                                uploadedSrc = {
                                    'FIRST_PICTURE': '0',
                                    'PERPICURL': data.PERPICURL,
                                    'F_S_LINK': data.F_S_LINK,
                                    'ORDERNUM': '0',
                                    'APPDESC': file.name.replace(/\.\w+$/, ''),
                                    'HEIGHT': data.HEIGHT,
                                    'ISDELETE': '0',
                                    'SRC_LINK': src.imgName,
                                    'CREATETIME': $filter('date')(new Date(), "yyyy/MM/dd HH:mm:ss").toString(),
                                    'SRCPICURL': data.SRCPICURL,
                                    'PIC_ID': data.PIC_ID,
                                    'WIDTH': data.WIDTH
                                };
                                if ($scope.status.progress == '100%') {
                                    $modalInstance.close(uploadedSrc);
                                }
                            }
                        }, function() {
                            modalDialog.alertType("图片上传失败", "请稍后再试", "error", false, function() {
                                $modalInstance.dismiss();
                            });
                        });
                    } else {
                        uploadedSrc = {
                            'PERPICURL': src.imgSrc,
                            'APPFILE': src.imgName,
                            'APPDESC': file.name.replace(/\.\w+$/, ''),
                        };
                        if ($scope.status.progress == '100%') {
                            $modalInstance.close(uploadedSrc);
                        }
                    }
                },
                error: function(file) {
                    $modalInstance.dismiss();
                },
                file: function(file, uploader) {
                    uploader.makeThumb(file[0], function(error, src) {
                        $timeout(function() {
                            $scope.status.uploadImg = {
                                'src': src
                            };
                        });
                    });
                    $scope.finish = function() {
                        $scope.status.lockBtn = true;
                        uploader.upload();
                    };
                },
                tar: function(file, percentage) {
                    $timeout(function() {
                        $scope.status.progress = Math.ceil(percentage * 100) + "%";
                    });
                },
                comp: function(file) {}
            };
        }
        $scope.close = function() {
            $modalInstance.dismiss();
        };
    }
]);
